module.exports = __webpack_public_path__ + "img/02.4de0f514.jpg";